<template>
    <div class="bodyContent-form">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="title wow fadeInUp">Verifying</h1>
                </div>
            </div>
            <div class="container text-center py-5">
                <div class="alert alert-danger" role="alert" v-if="error">
                    {{ error }}
                </div>
                <h1 v-show="!error">Please wait..</h1>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["hash"],

  data() {
    return {
      error: null
    };
  },

  mounted() {
    this.sendVerifyRequest(this.hash)
      .then(() => {
        this.$router.push("/my_account").catch(() => {});
      })
      .catch(error => {
        this.error = "Error verifying email";
        if (error.status === 204) {
          this.error = "Email is already verified";
        }

      });
  },

  computed: {
    ...mapGetters("auth", ["user"])
  },

  methods: {
    ...mapActions("auth", ["sendVerifyRequest"])
  }
};
</script>
